module.exports = __webpack_public_path__ + "static/media/ArrowUp.315e45a4.svg";